import React from "react";

const getMatches = (query: string): boolean => {
  if (typeof window !== "undefined") {
    return window.matchMedia(query).matches;
  }
  return false;
};

export function useMediaQuery(query: string, defaultValue?: boolean) {
  const [value, setValue] = React.useState(() => {
    if (typeof window !== "undefined") {
      return getMatches(query);
    }
    return defaultValue ?? false;
  });

  React.useEffect(() => {
    const result = matchMedia(query);

    const onChange = (event: MediaQueryListEvent) => {
      setValue(event.matches);
    };

    // Set initial value in case it changed between render and effect
    setValue(result.matches);

    result.addEventListener("change", onChange);
    return () => result.removeEventListener("change", onChange);
  }, [query]);

  return value;
}
